/*
 * @Author: Json Chen
 * @Date: 2021-07-05 16:48:24
 * @LastEditTime: 2021-07-07 17:50:19
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCookies/Preview/index.tsx
 */
import React from 'react';
import { Cookies } from 'unifyxp-ecomm-components';
import PreviewContainer from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import styles from '../style.module.less';

function Preview(props) {
  return (
    <PreviewContainer className={styles.previewContainer}>
      <div className={styles.cookiesContainer}>
        <Cookies {...props} />
      </div>
    </PreviewContainer>
  );
}

export default Preview;
